export const GET_ANONYMOUS_USER_SOLUTIONS_REQUEST =
  "GET_ANONYMOUS_USER_SOLUTIONS_REQUEST";
export const GET_ANONYMOUS_USER_SOLUTIONS_SUCCESS =
  "GET_ANONYMOUS_USER_SOLUTIONS_SUCCESS";
export const GET_ANONYMOUS_USER_SOLUTIONS_FAIL =
  "GET_ANONYMOUS_USER_SOLUTIONS_FAIL";
